import { createContext, useContext, useState } from "react";

interface EntitiesProviderProps {
  children: React.ReactNode;
}

type EntitiesContextType = {
  entities?: any;
  setEntities: (entities: any) => void;
};

export const EntitiesContext = createContext<EntitiesContextType>({
  entities: undefined,
  setEntities: () => {},
});

const EntitiesProvider = (props: EntitiesProviderProps) => {
  const [entities, setEntities] = useState<any>();

  return (
    <EntitiesContext.Provider value={{ entities, setEntities }}>
      {props.children}
    </EntitiesContext.Provider>
  );
};

export default EntitiesProvider;

export const useEntities = () => {
  const { entities, setEntities } = useContext(EntitiesContext);
  return { entities, setEntities };
};
